<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card>
      <ib-dialog-header title="Transferir departamento em massa" subtitle="Transfira todas as conversas em aberto para outro departamento. O chatbot e o tipo de atendimento não são alterados: as conversas continuam exatamente como estão, apenas mudam de departamento." :close="closeDialog"></ib-dialog-header>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <ib-autocomplete v-model="department" outlined :items="departments" item-text="name" item-value="_id" label="Departamento de destino" no-data-text="Não há departamentos" hide-details="auto" return-object />
          </v-col>

          <v-col cols="12">
            <v-switch v-model="useFilters" inset label="Usar filtros ativos da tela de atendimento" hide-details="auto" />
          </v-col>

          <v-col v-if="useFilters && hasActiveFilters" cols="12">
            <v-card outlined class="pa-3" style="border-radius: 9px;">
              <div class="text-subtitle-2 mb-2">Filtros que serão aplicados:</div>
              <v-chip v-if="filterSummary.types" small class="ma-1">{{ filterSummary.types }}</v-chip>
              <v-chip v-if="filterSummary.departments" small class="ma-1">{{ filterSummary.departments }}</v-chip>
              <v-chip v-if="filterSummary.tags" small class="ma-1">{{ filterSummary.tags }}</v-chip>
              <v-chip v-if="filterSummary.chips" small class="ma-1">{{ filterSummary.chips }}</v-chip>
              <v-chip v-if="filterSummary.situation" small class="ma-1">{{ filterSummary.situation }}</v-chip>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <ib-btn color="gray200" outlined @click="closeDialog">
          <div class="gray1000--text">
            Cancelar
          </div>
        </ib-btn>
        <v-spacer />
        <ib-btn color="primary" :loading="loading" :disabled="!department" @click="transferConversationsDepartment">
          Transferir conversas
        </ib-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    activeFilters: {
      type: Object,
      default: () => ({})
    },
    preFilters: {
      type: Object,
      default: () => ({})
    },
    tags: {
      type: Array,
      default: () => []
    },
    departments: {
      type: Array,
      default: () => []
    },
    chips: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      department: null,
      useFilters: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    currentUser() {
      return this.$store.state.currentUser;
    },

    hasActiveFilters() {
      const situationId = typeof this.preFilters.situation === 'object' ? this.preFilters.situation?.id : this.preFilters.situation;

      return this.preFilters.departments?.length > 0 ||
        this.preFilters.tags?.length > 0 ||
        this.preFilters.chips?.length > 0 ||
        this.preFilters.types?.length !== 2 ||
        (situationId && situationId !== 'all');
    },

    filterSummary() {
      const summary = {};

      if (this.preFilters.types && this.preFilters.types.length === 1) {
        summary.types = `Tipo: ${this.preFilters.types[0].name}`;
      }

      if (this.preFilters.departments?.length > 0) {
        const names = this.preFilters.departments.map(d => d.name).join(', ');
        summary.departments = `Departamentos: ${names}`;
      }

      if (this.preFilters.tags?.length > 0) {
        const names = this.preFilters.tags.map(t => t.name).join(', ');
        summary.tags = `Tags: ${names}`;
      }

      if (this.preFilters.chips?.length > 0) {
        const names = this.preFilters.chips.map(c => c.name).join(', ');
        summary.chips = `Chips: ${names}`;
      }

      if (this.preFilters.situation) {
        this.preFilters.situation.name != 'Todas' ? summary.situation = `Situação: ${this.preFilters.situation.name}` : summary.situation = 'Situação: Todas';
      }

      return summary;
    }
  },
  methods: {
    clear() {
      this.department = null;
      this.useFilters = false;
    },

    closeDialog() {
      this.clear();
      this.dialog = false;
    },

    async transferConversationsDepartment() {
      if (!this.department) return this.$toast("error", "É necessário selecionar o departamento de destino");

      this.loading = true;

      const payload = { department_id: this.department._id };

      if (this.useFilters) {
        payload.filter = {};

        if (this.preFilters.types && this.preFilters.types.length === 1) payload.filter.is_manual = this.preFilters.types[0].id === 'human';

        if (this.preFilters.departments?.length > 0) payload.filter.departments = this.preFilters.departments.map(d => d._id);

        if (this.preFilters.tags?.length > 0) payload.filter.tags = this.preFilters.tags.map(t => t._id);

        if (this.preFilters.chips?.length > 0) payload.filter.chips = this.preFilters.chips.map(c => c._id);

        if (this.preFilters.situation?.name != 'Todas') payload.filter.waiting_response = true;
      }

      const resp = await this.$api.transferConversationsDepartment(payload);
      this.loading = false;

      if (!resp.error && resp.message) {
        const total = resp.message.modifiedCount || 0;
        this.$toast("success", total === 1 ? "1 conversa transferida com sucesso!" : `${total} conversas transferidas com sucesso!`);
        this.closeDialog();
      }
    },
  }
};
</script>
